module.exports = __webpack_public_path__ + "static/PFB__0008_Map-3566cf8f04e30f43d1256c06f2822b35.png";